// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header__LC_4roR9ta{grid-auto-columns:1fr}", "",{"version":3,"sources":["webpack://./src/assets/fable/flowEditor/components/flowEditorChrome/flowEditorChrome.module.scss"],"names":[],"mappings":"AAAA,oBAEE,qBAAA","sourcesContent":[".header {\n  // Makes the column slots equal width, ensuring the middle slow is always centered.\n  grid-auto-columns: 1fr;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "header__LC_4roR9ta"
};
export default ___CSS_LOADER_EXPORT___;
